// Color combinations using categorical palette (background = tint, text = shade)
// Unable to use class names directly because Tailwind CSS doesn't support dynamic class names
const PAYER_COLOR_COMBOS = [
  // Chart colors - background = tint, text = shade. Taken from Insights.
  { backgroundColor: '#CBEEF5', color: '#047289' }, // chart-1-tint/shade
  { backgroundColor: '#DAE5F5', color: '#08489C' }, // chart-2-tint/shade
  { backgroundColor: '#D7E7C0', color: '#467202' }, // chart-3-tint/shade
  { backgroundColor: '#FFEDD0', color: '#C07800' }, // chart-4-tint/shade
  { backgroundColor: '#DFE4FF', color: '#2643C7' }, // chart-5-tint/shade
  { backgroundColor: '#FFE3DA', color: '#C74118' }, // chart-6-tint/shade
  { backgroundColor: '#E4E4E7', color: '#71717A' }, // chart-empty/dark-gray
];

// Export the color combinations for use in other files
export { PAYER_COLOR_COMBOS };
